import React from "react";
import styles from "./index.module.css";

const FallBackUI = <div className={styles.fallback} />;

export default FallBackUI;
